import debug from '../utilities/debug';

export type WatchTelemetryCategory = 'watch-sync' | 'watch-queue' | 'watch-connectivity';

function sanitizeData(data?: Record<string, unknown>): Record<string, unknown> | undefined {
  if (!data) return undefined;
  const cloned = { ...data };
  delete cloned.accessToken;
  delete cloned.idToken;
  delete cloned.refreshToken;
  delete cloned.rawBase64;
  return cloned;
}

export function createWatchCorrelationId(prefix = 'watch'): string {
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}

export function watchLog(category: WatchTelemetryCategory, message: string, data?: Record<string, unknown>): void {
  debug.log(category, message, sanitizeData(data));
}

export function watchInfo(category: WatchTelemetryCategory, message: string, data?: Record<string, unknown>): void {
  debug.info(category, message, sanitizeData(data));
}

export function watchWarn(message: string, data?: Record<string, unknown>): void {
  debug.warn(message, sanitizeData(data));
}

export function watchError(message: string, data?: Record<string, unknown>): void {
  debug.error(message, sanitizeData(data));
}
